import { WHITE } from '@styles/colors';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 24px;
`;

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 12px 24px 12px;
  width: 100%;
  background-color: ${WHITE};
`;
